var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 10.2093C0.5 4.57085 5.07085 0 10.7093 0C16.3477 0 20.9186 4.57085 20.9186 10.2093C20.9186 15.8477 16.3477 20.4186 10.7093 20.4186C5.07085 20.4186 0.5 15.8477 0.5 10.2093ZM11.6475 6.50024C11.6475 5.98248 11.2277 5.56274 10.71 5.56274C10.1922 5.56274 9.77246 5.98248 9.77246 6.50024V10.209C9.77246 10.5224 9.92912 10.8151 10.1899 10.989L12.9715 12.8434C13.4023 13.1306 13.9843 13.0142 14.2715 12.5833C14.5587 12.1525 14.4423 11.5705 14.0115 11.2833L11.6475 9.70722V6.50024Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.eede43b6293ab48e646f6fa6c661b52c.svg";
export { ForwardRef as ReactComponent };